/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["crupdate-role-modal{display:block}crupdate-role-modal .setting-container{margin-bottom:25px}crupdate-role-modal .setting-container>p{color:rgba(0,0,0,.54);margin:5px 0}"];
export { styles as styles };
